export default __webpack_public_path__ + "static/media/search.9a296b2a.svg";